// extracted by mini-css-extract-plugin
export var chip = "_df-0";
export var filterDropdown = "_df-5";
export var filterItem = "_df-6";
export var icon = "_df-1";
export var removeButton = "_df-3";
export var removeIcon = "_df-4";
export var separator = "_df-2";